import { memo, useCallback } from "react";
import { useHistory } from "react-router-dom";

import { adminRoute } from "@/config/roles";
import { Badge2 } from "@/ui2/atoms/Badge";
import { Cell2 } from "@/ui2/atoms/(table)/Cell";
import { Menu2 } from "@/ui2/molecules/Menu";
import { Row2 } from "@/ui2/molecules/(table)/Row";

import type { AdaptedCsmRow } from "../../helpers/adapters";

type CsmTableRowProps = {
  row: AdaptedCsmRow;
};

type CsmRowAction = "view_profile";

const ACTION_ITEMS = [{ id: "view_profile", label: "View Profile" }] satisfies {
  id: CsmRowAction;
  label: string;
}[];

function CsmTableRowComponent({ row }: CsmTableRowProps) {
  const history = useHistory();

  const handleActionClick = useCallback(
    (key: CsmRowAction) => {
      switch (key) {
        case "view_profile":
          history.push(`${adminRoute}/profile/admin/${row.username}`);
          break;

        default:
          key satisfies never;
      }
    },
    [history, row.username],
  );

  return (
    <Row2 id={row.id}>
      <Cell2>{row.name}</Cell2>
      <Cell2>{row.email}</Cell2>
      <Cell2>{row.mobile || "–"}</Cell2>

      <Cell2>
        <Badge2 size="xs" variant="success">
          Active
        </Badge2>
      </Cell2>

      <Cell2 className="tw:py-3">
        <Menu2
          classNameTrigger="tw:align-middle"
          items={ACTION_ITEMS}
          onAction={handleActionClick}
          placement="left top"
        />
      </Cell2>
    </Row2>
  );
}

export const CsmTableRow = memo(CsmTableRowComponent);
